import React from 'react';
import "./main.css";
import Более from "../../images/Choose/Более.png";
import Бесплатное from "../../images/Choose/Бесплатное.png";
import Работа from "../../images/Choose/Работа.png";
import Гарантия from "../../images/Choose/Гарантия.png";
import Выгодные from "../../images/Choose/Выгодные.png";

export default function Choose() {
    return (
        <div className='choose'>
            <h1 className='title'>Почему выбирают нас?</h1>
            <div className="choose-header">
                <div className="choose-header-box">
                    <img src={Более} alt="error" />
                    <h2>Более 10 лет</h2>
                    <p>Опыт работы <br /> нашей компании</p>
                </div>
                <div className="choose-header-box">
                    <img src={Бесплатное} alt="error" />
                    <h2>Бесплатное</h2>
                    <p>Сервисное <br /> обслуживание</p>
                </div>
                <div className="choose-header-box">
                    <img src={Работа} alt="error" />
                    <h2>Работа по ГОСТу</h2>
                    <p>Вся продукция <br /> сертифицирована</p>
                </div>
                <div className="choose-header-box">
                    <img src={Гарантия} alt="error" />
                    <h2>Гарантия 5 лет</h2>
                    <p>Мы ручаемся за качество</p>
                </div>
                <div className="choose-header-box">
                    <img src={Выгодные} alt="error" />
                    <h2>Выгодные цены</h2>
                    <p>Мы ручаемся за качество</p>
                </div>
            </div>
        </div>
    )
}
